import { Component } from "@angular/core";

@Component({
  selector: "app-property-occupancy-technical-installation-consent",
  templateUrl:
    "./property-occupancy-technical-installation-consent.component.html",
  standalone: false,
})
export class PropertyOccupancyTechnicalInstallationConsentComponent {}
